import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import './bulkInviteSlidePanel.scss'
import { BulkUsersImportTable } from './bulkUsersImportTable';
import { DownloadUploadExcel } from './downloadUploadExcel';
import { useQueryDictionary } from "../../../../hooks/useQueryDictionary";

type Props = {
  setBulkInviteSlide: Dispatch<SetStateAction<boolean>>;
  bulkInviteSlide: boolean;
  reloadData: (options?: any) => void;
};

export function BulkInviteSlidingPanel(props: Props) {
  const {setBulkInviteSlide, bulkInviteSlide, reloadData} = props;
  const [slide, setSlide] = useState<number>(0);
  const [jsonParse, setJsonParse] = useState<any[]>([]);
  const accountOptions = useQueryDictionary({dictionary: 'Customers'});
  const schoolOptions = useQueryDictionary({dictionary: 'Schools'});

  useEffect(() => {
    if (jsonParse.length > 0) setSlide(1);
  }, [jsonParse])

  const closeSlide = () => {
    setSlide(0);
    setBulkInviteSlide(false);
    reloadData();
  }

  return (
    <div>
      <SlidingPane
        width="90%"
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={bulkInviteSlide}
        title="Bulk Invite Users"
        subtitle={slide === 0 ? "Download our bulk upload Excel file (XLSX), fill it out and bulk upload your contacts." : ""}
        onRequestClose={closeSlide}
      >
        {slide === 0 ?
          <DownloadUploadExcel setJsonParse={setJsonParse} accountOptions={accountOptions}
                               schools={schoolOptions}/> :
          <BulkUsersImportTable jsonParse={jsonParse} accountOptions={accountOptions}
                                schoolOptions={schoolOptions} closeSlide={closeSlide}/>
        }
      </SlidingPane>
    </div>
  );
}
